if ($(".id-29").length) {
  function showCopyNotice($bank) {
    $(".bank #copyNotice").stop(true, true).remove();
    const $notice = $('<div id="copyNotice" role="status">Zkopírováno</div>').appendTo($bank);
    setTimeout(function () {
      $notice.fadeOut(200, function () {
        $(this).remove();
      });
    }, 2000);
  }

  $(".bank .tls")
    .attr("title", "Kliknutím zkopírujete číslo účtu")
    .on("click", function () {
      const value = $(this).text().trim();
      const $bank = $(this).closest(".bank");

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(value).then(function () {
          showCopyNotice($bank);
        });
        return;
      }

      const input = $("<textarea>").val(value).appendTo("body").select();
      if (document.execCommand("copy")) {
        showCopyNotice($bank);
      }
      input.remove();
    });
}
